<template>
  <helper-layout :loaded="mx_loaded">
    <material-table
      :search-data="searchData"
      :headers="headers"
      :items="warehouseList.items"
      :paginate="paginateConfig"
      :sort-data.sync="sortData"
      :total-count="warehouseList.totalCount"
      @pageChange="handlePageChange"
      @searchChange="handleSearchChange"
    >
      <!-- 表格顶部工具栏 -->
      <template v-slot:toolbar>
        <v-layout justify-space-between class="toolbar">
          <v-flex shrink>
            &nbsp;
          </v-flex>
          <v-flex shrink>
            <v-btn
              color="success"
              solid
              @click="addWarehouse('add', null)"
            >
              <!-- 新增 -->
              {{ $t("Views.Warehouse.create") }}
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
    </material-table>

    <!-- 新增修改 弹窗 -->
    <material-dialog
      :visible="showDialog"
      :title="
        editForm.isEdit
          ? $t('Views.Warehouse.editWarehouse')
          : $t('Views.Warehouse.newWarehouse')
      "
      :width="600"
      @cancleFn="cancel"
      @confirmFn="save"
    >
      <template>
        <v-form ref="form" v-model="valid" lazy-validation>
          <!-- 倉庫名称 -->
          <v-layout row>
            <v-flex>
              <span class="required-mark">*</span>
              <v-text-field
                v-model="editForm.name"
                :validate-on-blur="true"
                :placeholder="$t('Views.Warehouse.warehouseNamePlease')"
                :label="$t('Views.Warehouse.warehouseName')"
                required
                counter
                maxlength="32"
                :rules="nameRules"
              />
            </v-flex>
          </v-layout>
          <!-- 倉庫コード -->
          <v-layout row>
            <v-flex>
              <span class="required-mark">*</span>
              <v-text-field
                v-model="editForm.code"
                :validate-on-blur="true"
                :placeholder="$t('Views.Warehouse.warehouseCodePlease')"
                :label="$t('Views.Warehouse.warehouseCode')"
                required
                counter
                maxlength="32"
                :rules="codeRules"
              />
            </v-flex>
          </v-layout>
        </v-form>
      </template>
    </material-dialog>

    <material-dialog
      :width="500"
      :visible="showModal"
      :title="modalTitle"
      @cancleFn="cancelDialog"
      @confirmFn="confirmDialog"
    >
      <template><span class="desc">{{ modalWaring }}</span>
      </template>
    </material-dialog>
  </helper-layout>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { pageLoadMx } from '@/plugins/mixins'
export default {
  mixins: [pageLoadMx],
  data() {
    const $t = this.$t.bind(this)
    return {
      valid: true,
      showDialog: false,
      editForm: {},
      // 表格header栏配置
      headers: [
        {
          // 倉庫名称
          text: $t('Views.Warehouse.warehouseName'),
          value: 'name',
          width: 250
        },
        {
          // 倉庫コード,
          text: $t('Views.Warehouse.warehouseCode'),
          value: 'code',
          width: 250
        },
        {
          // 操作
          text: $t('Views.Warehouse.action'),
          value: 'action',
          width: 100,
          actions: [
            {
              // 修改
              text: $t('Views.Warehouse.edit'),
              color: this.$store.state.app.editBtnColor,
              visible: row => {
                return true
              },
              actionFn: row => {
                this.addWarehouse('edit', row.row)
              }
            },
            {
              // 删除
              text: $t('Views.Warehouse.delete'),
              color: this.$store.state.app.banBtnColor,
              visible: row => {
                return (
                  row.row.status !== 'OnSale' &&
                  this.$util.tool.hasPerm(
                    'ProductManager.ProductsList.Delete'
                  )
                )
              },
              actionFn: row => {
                this.openModal('del', row.row)
              }
            }
          ]
        }
      ], // 表格数据检索配置
      searchData: [
        {
          key: 'name',
          value: '',
          // 倉庫名称
          label: $t('Views.Warehouse.warehouseName'),
          placeholder: $t('Views.Warehouse.warehouseNamePlease')
        },
        {
          key: 'code',
          value: '',
          // 倉庫コード
          label: $t('Views.Warehouse.warehouseCode'),
          placeholder: $t('Views.Warehouse.warehouseCodePlease')
        }
      ], // 表格分页配置
      paginateConfig: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      // 表格排序配置
      sortData: {
        descending: false
      },
      // 表格搜索项
      form: {
        name: '',
        warehouseCode: '',
        sorting: '',
        skipCount: 0,
        maxResultCount: 10
      },
      showModal: false,
      warehouseId: null,
      modalTitle: '',
      modalWaring: '',
      modalType: '',
      nameRules: [v => !!v || $t('Views.Mine.rule_empty_label', { 0: $t('Views.Warehouse.warehouseName') })],
      codeRules: [v => !!v || $t('Views.Mine.rule_empty_label', { 0: $t('Views.Warehouse.warehouseCode') })]
    }
  },
  computed: {
    ...mapState('warehouse', ['warehouseList']),
    ...mapState('app', ['color', 'disableColor'])
  },
  mounted() {
    this.getPage()
  },
  methods: {
    ...mapActions('warehouse', [
      'getWarehousesList',
      'addWarehouseApi',
      'editWarehouseApi',
      'delWarehouse'
    ]),
    cancel() {
      this.showDialog = false
    },
    save() {
      if (this.$refs.form.validate()) {
        const param = this.$_.cloneDeep(this.editForm)

        if (this.editForm.isEdit) {
          this.editWarehouseApi(param).then(() => {
            this.getPage()
            this.showDialog = false
            this.editForm = {}
          })
        } else {
          this.addWarehouseApi(param).then(() => {
            this.getPage()
            this.showDialog = false
            this.editForm = {}
          })
        }
      }
    },
    getPage(page) {
      if (typeof page !== 'undefined') {
        this.paginateConfig.page = page
        this.form.skipCount = (page - 1) * this.form.maxResultCount
      }
      if (!this.mx_loaded) this.mx_loading_fn() // 页面加载中
      this.getWarehousesList(this.form).then(() => {
        this.paginateConfig.total = this.warehouseList.totalCount
        this.mx_loaded_fn() // 页面加载完成
      })
    },
    deleteWarehouse(id) {
      this.delWarehouse(id).then(ret => {
        this.$store.commit('app/setNotification', {
          msg: this.$t('Views.Warehouse.deleteSuccess'),
          type: 'success'
        })
        // 刷新页面
        this.getPage(1)
      })
    },
    handleSearchChange(search) {
      this.form = { ...this.form, ...search }
      this.getPage(1)
    },
    handlePageChange(page) {
      this.getPage(page)
    },
    addWarehouse(type, row) {
      this.editForm = {}
      this.$refs.form && this.$refs.form.resetValidation()
      this.editForm.isEdit = (type === 'edit')
      if (this.editForm.isEdit) {
        this.editForm.id = row.id
        this.editForm.name = row.name
        this.editForm.code = row.code
      }
      this.showDialog = true
    },
    cancelDialog() {
      this.showModal = false
    },
    confirmDialog() {
      if (this.modalType === 'del') {
        this.deleteWarehouse(this.warehouseId)
      }
      this.showModal = false
    },
    openModal(type, param) {
      this.showModal = true
      this.modalTitle = this.$t('Views.Warehouse.pleaseConfirm')
      this.modalType = type
      this.warehouseId = param.id
      if (type === 'del') {
        this.modalWaring = this.$t('Views.Warehouse.suredel', {
          '0': param.name
        })
      }
    },
    getPermission(name) {
      return this.$util.tool.hasPerm(name)
    }
  }
}
</script>
<style lang="scss" scoped>
  .flex {
    position: relative;
  }
  .oright {
    text-align: right;
    margin-bottom: 10px;
  }
  .card-box {
    padding: 24px 16px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 0 10px 2px #eee;
    font-size: 13px;
    width: 100%;
  }
  .header-bar {
    font-weight: bold;
    font-size: 14px;
    border-bottom: 1px solid #e0e0e0;
    line-height: 24px;
    color: #515151;
  }
  .v-treeview-node__root {
    font-size: 14px;
    border-bottom: 1px solid #f4f4f4;
  }
  .v-treeview-node__label {
    font-size: 13px !important;
  }
  /deep/ .v-treeview-node__children .v-treeview-node--leaf {
    margin-left: 26px;
  }
  .v-btn__content .v-icon {
    font-size: 20px;
  }
  .theme--light.v-icon.v-treeview-node__toggle--open {
    color: #9c27b0;
  }
  .required-mark {
    color: red;
    font-size: 14px;
    font-weight: 700;
    line-height: 26px;
    vertical-align: middle;
    position: absolute;
    top: 0;
    left: -10px;
    /* float: left; */
  }
  .flex-none {
    flex: none;
  }
  .fisrt-cate {
    width: 27%;
  }
  .second-cate {
    width: 28%;
  }
  .third-cate {
    width: 28.2%;
  }
  .fisrt-action {
    width: 36%;
  }
  .second-action {
    width: 36.8%;
  }
  .third-action {
    width: 36.8%;
  }
</style>
